import { IPoi } from './poi.types';

/** POIs whose coords fall inside a bounding box (north/south/east/west). */
export function poisInBounds(
  pois: IPoi[],
  bounds: { north: number; south: number; east: number; west: number },
): IPoi[] {
  return pois.filter(p =>
    p.coordinates.lat <= bounds.north && p.coordinates.lat >= bounds.south
    && p.coordinates.lon <= bounds.east && p.coordinates.lon >= bounds.west,
  );
}
